module.exports = __webpack_public_path__ + "brand-logo-alternative-f4a5f.png";